<template>
  <div id="Graphs">
    <SovecoNavBar />
    <div class="columns is-variable">
      <div class="column is-narrow">
        <div class="graphs_top_box">MEZZI</div>
        <VueScrollTable
          :options="vehiclesOpts"
          :columns="vehiclesCols"
          :rows="vehiclesRows"
        />
      </div>
      <div class="column">
        <div class="has-text-centered has-text-weight-bold has-text-black">
          {{ vehicleSel.targa }}
          <br />
          {{ s1 }}&nbsp;{{ s2 }}&nbsp;{{ s3 }}&nbsp;{{ s4 }}
        </div>
        <div v-if="noData" class="columns is-mobile is-centered">
          <div class="column is-half">
            <p class="has-text-centered has-text-weight-bold has-text-black">
              <br />
              <br />
              Non esistono posizioni in questa data per questo mezzo
            </p>
          </div>
        </div>
        <div v-if="!noData" id="linechart">
          <canvas id="line_graphs"></canvas>
        </div>

        <div id="footer">
          <div class="columns">
            <div class="column">
              <table>
                <tr>
                  <td style="vertical-align: middle">Inizio</td>
                  <td>
                    <date-picker
                      v-model="datePickerValue_start"
                      type="datetime"
                      value-type="YYYY-MM-DD HH:mm"
                      format="DD-MM-YYYY HH:mm"
                      confirm
                    ></date-picker>
                  </td>
                </tr>
                <tr>
                  <td style="vertical-align: middle">Fine</td>
                  <td>
                    <date-picker
                      v-model="datePickerValue_end"
                      type="datetime"
                      value-type="YYYY-MM-DD HH:mm"
                      format="DD-MM-YYYY HH:mm"
                      confirm
                    ></date-picker>
                  </td>
                </tr>
              </table>
            </div>
            <div class="column">
              <a
                class="button is-link"
                :disabled="!carbFlag || noData"
                @click="setCarburanteGraphs"
                >Carburante</a
              >
            </div>
            <div class="column">
              <a
                class="button is-success"
                :disabled="!tempFlag || noData"
                @click="setTemperatureGraphs"
                >Temperatura</a
              >
            </div>
            <div class="column">
              <a
                class="button is-info"
                :disabled="noData"
                @click="setSpeedGraphs"
                >Velocità</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Chart from 'chart.js'
import { ServiceBus } from '../ServiceBus.js'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/it'
import { UtilityMixin } from '../mixins/UtilityMixin.js'

import VueScrollTable from './reusable/VueScrollTable.vue'
export default {
  name: 'Graphs',
  components: {
    VueScrollTable,
    DatePicker,
  },
  mixins: [UtilityMixin],
  data() {
    return {
      myChart: null,
      noData: false,
      flag: 0,
      apiServer: '',
      auth: null,
      prefs: null,
      windowHeight: 0,
      vehiclesRows: [],
      s1: '',
      s2: '',
      s3: '',
      s4: '',
      tempFlag: false,
      carbFlag: false,

      datasets: {},
      labels: [],
      speed_data: [],
      s0_data: [],
      s1_data: [],
      s2_data: [],
      s3_data: [],
      s4_data: [],
      dataGraph: [],
      vehicleSel: {},
      datePickerValue_start: '',
      datePickerValue_end: '',
      startData: '',
      endData: '',

      chartOpt: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'hour',
                min: this.startData,
                max: this.endData,
                displayFormats: {
                  hour: 'HH:mm',
                },
              },
              ticks: {
                major: {
                  enabled: true, // <-- This is the key line
                  fontStyle: 'bold', //You can also style these values differently
                  fontSize: 14, //You can also style these values differently
                },
              },
            },
          ],
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0,
            },
          },
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
      datacollection: {
        datasets: [
          {
            label: '',
            fill: false,
            backgroundColor: '#f87979',
            data: [],
          },
        ],
      },
      vehiclesOpts: {
        id: 'VH01',
        isResizeable: false,
        isSelectable: true,
        cssContainer: 'graphs_lc',
        cssHeader: 'vehicles_lh',
        cssBody: 'vehicles_l',
        cssRows: 'vehicles_l',
        order_col: 'targa',
      },
      vehiclesCols: [
        {
          id: 'targa',
          visible: true,
          f_type: '*',
          title: 'Targa',
          width: 100,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: 0,
          image: false,
        },
        {
          id: 'sonda_1',
          visible: true,
          f_type: '*',
          title: '',
          width: 25,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'sonda_2',
          visible: true,
          f_type: '*',
          title: '',
          width: 25,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'sonda_3',
          visible: true,
          f_type: '*',
          title: '',
          width: 25,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: -1,
          image: false,
        },
        {
          id: 'sonda_4',
          visible: true,
          f_type: '*',
          title: '',
          width: 25,
          alignment_th: '',
          alignment_td: '',
          elastic: false,
          filter: '',
          order: -1,
          image: false,
        },
      ],
    }
  },
  watch: {
    // whenever question changes, this function will run
    datePickerValue_end(newDataPickerValue, oldDataPickerValue) {
      const vm = this
      let d_end = vm.newDate(newDataPickerValue)
      let d_start = vm.newDate(vm.datePickerValue_start)

      if (d_end >= d_start) {
        vm.endData = d_end.toLocaleMysqlString()

        vm.startData = d_start.toLocaleMysqlString()

        if (!vm.isEmptyObject(vm.vehicleSel)) {
          vm.doGetPos()
        }
      } else if (vm.datePickerValue_start.length > 0) {
        vm.$dialog
          .alert('Controlllare le date inserite!')
          .then(function () {})
          .catch(function () {})
      }
    },
    datePickerValue_start(newDataPickerValue, oldDataPickerValue) {
      const vm = this
      let d_start = vm.newDate(newDataPickerValue)
      let d_end = vm.newDate(vm.datePickerValue_end)

      if (d_end >= d_start) {
        vm.endData = d_end.toLocaleMysqlString()
        vm.startData = d_start.toLocaleMysqlString()

        if (!vm.isEmptyObject(vm.vehicleSel)) {
          vm.doGetPos()
        }
      } else if (vm.datePickerValue_end.length > 0) {
        vm.$dialog
          .alert('Controlllare le date inserite!')
          .then(function () {})
          .catch(function () {})
      }
    },
  },
  created() {
    const vm = this
    vm.prefs = JSON.parse(vm.$localStorage.get('prefs'))
    vm.auth = JSON.parse(vm.$localStorage.get('auth'))
  },
  mounted() {
    const vm = this
    vm.api_server = vm.getApiServer()
    ServiceBus.setApi(vm.api_server)
    ServiceBus.setAuth(vm.auth)
    if (vm.auth === null) {
      vm.$router.push({
        path: 'login',
      })
    }
    vm.$nextTick(function () {
      window.removeEventListener('resize', null)
      window.addEventListener('resize', vm.getWindowHeight)
      vm.getWindowHeight()
      let d = new Date()
      d.setHours(0)
      d.setMinutes(0)
      d.setSeconds(0)
      vm.datePickerValue = d.toISOString()
      vm.doGetVehicles()
      moment.locale('it-IT')
    })
  },
  methods: {
    createChart() {
      const vm = this
      const ctx = document.getElementById('line_graphs')

      if (vm.myChart !== null) {
        vm.myChart.destroy()
      }

      vm.myChart = new Chart(ctx, {
        type: 'line',
        data: vm.datacollection,
        options: vm.chartOpt,
      })
    },
    sondaName(n, idx) {
      let vm = this
      let name = ''

      if (n !== '') {
        if (n == 'C') {
          vm.carbFlag = true
          name = 'S' + idx + ' Carburante'
        } else if (n == 'T' || n == 'V') {
          vm.tempFlag = true
          name = 'S' + idx + ' Temperatura'
        }
      }
      return name
    },
    colClick(id, col, item) {
      const vm = this
      vm.selectVehicle(item)
    },
    selectVehicle(item) {
      const vm = this
      vm.vehicleSel = item
      vm.carbFlag = false
      vm.tempFlag = false
      vm.s1 = vm.sondaName(item.sonda_1, 1)
      vm.s2 = vm.sondaName(item.sonda_2, 2)
      vm.s3 = vm.sondaName(item.sonda_3, 3)
      vm.s4 = vm.sondaName(item.sonda_4, 4)
      vm.doGetPos()
    },
    async doGetVehicles() {
      const vm = this
      vm.isLoading = true
      vm.vehiclesRows = await ServiceBus._doGetVehicles()
      if (vm.isEmptyObject(vm.vehicleSel)) {
        vm.selectVehicle(vm.vehiclesRows[0])
      }
      vm.isLoading = false
    },

    setSpeedGraphs() {
      const vm = this
      vm.datacollection = {
        labels: vm.labels,
        datasets: [
          {
            label: 'Velocità',
            fill: false,
            backgroundColor: '#f87979',
            data: vm.speed_data,
          },
        ],
      }
      vm.chartOpt = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Velocità',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Km/h',
              },
            },
          ],
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'hour',
                min: this.startData,
                max: this.endData,
                displayFormats: {
                  hour: 'HH:mm',
                },
              },
              ticks: {
                major: {
                  enabled: true, // <-- This is the key line
                  fontStyle: 'bold', //You can also style these values differently
                  fontSize: 14, //You can also style these values differently
                },
              },
            },
          ],
        },
      }
      vm.flag++
      setTimeout(function () {
        vm.createChart()
      }, 500)
    },
    setCarburanteGraphs() {
      const vm = this

      if (!vm.carbFlag || vm.noData) {
        return
      }
      let c = 0
      const data = vm.s0_data.map(Number).filter((it) => it > 10)
      vm.datacollection = {
        labels: vm.labels,
        datasets: [
          {
            label: 'Carburante Tot',
            fill: false,
            backgroundColor: 'rgba(0,0,0,1)',
            borderColor: 'rgba(0,0,0,0.4)',
            data: data, // vm.s0_data,
          },
        ],
      }
      vm.datacollection.datasets = [
        {
          label: 'Carburante Tot',
          fill: false,
          backgroundColor: 'rgba(0,0,0,1)',
          borderColor: 'rgba(0,0,0,0.4)',
          data: data, // vm.s0_data,
        },
      ]
      if (vm.vehicleSel.sonda_1 == 'C') {
        c++
        vm.datacollection.datasets.push({
          label: 'S' + c,
          fill: false,
          backgroundColor: 'rgba(255,0,0,1)',
          borderColor: 'rgba(255,0,0,0.4)',
          data: vm.s1_data,
        })
      }
      if (vm.vehicleSel.sonda_2 == 'C') {
        c++
        vm.datacollection.datasets.push({
          label: 'S' + c,
          fill: false,
          backgroundColor: 'rgba(255,255,0,1)',
          borderColor: 'rgba(255,255,0,0.4)',
          data: vm.s2_data,
        })
      }
      if (vm.vehicleSel.sonda_3 == 'C') {
        c++
        vm.datacollection.datasets.push({
          label: 'S' + c,
          fill: false,
          backgroundColor: 'rgba(0,255,0,1)',
          borderColor: 'rgba(0,255,0,0.4)',
          data: vm.s3_data,
        })
      }
      if (vm.vehicleSel.sonda_4 == 'C') {
        c++
        vm.datacollection.datasets.push({
          label: 'S' + c,
          fill: false,
          backgroundColor: 'rgba(0,0,255,1)',
          borderColor: 'rgba(0,0,255,0.4)',
          data: vm.s4_data,
        })
      }
      if (c == 1) {
        let temp = vm.datacollection.datasets[0]
        vm.datacollection.datasets = []
        vm.datacollection.datasets.push(temp)
      }
      vm.chartOpt = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Carburante',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Litri',
              },
            },
          ],
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'hour',
                min: this.startData,
                max: this.endData,
                displayFormats: {
                  hour: 'HH:mm',
                },
              },
              ticks: {
                major: {
                  enabled: true, // <-- This is the key line
                  fontStyle: 'bold', //You can also style these values differently
                  fontSize: 14, //You can also style these values differently
                },
              },
            },
          ],
        },
      }
      vm.flag++
      setTimeout(function () {
        vm.createChart()
      }, 500)
    },
    setTemperatureGraphs() {
      const vm = this
      if (!vm.tempFlag || vm.noData) {
        return
      }
      let c = 0
      vm.datacollection.labels = vm.labels
      vm.datacollection.datasets = []
      if (vm.vehicleSel.sonda_1 == 'T' || vm.vehicleSel.sonda_1 == 'V') {
        c++
        vm.datacollection.datasets.push({
          label: 'S' + c,
          fill: false,
          backgroundColor: 'rgba(0,0,255,1)',
          borderColor: 'rgba(0,0,255,0.4)',
          data: vm.s1_data,
        })
      }
      if (vm.vehicleSel.sonda_2 == 'T' || vm.vehicleSel.sonda_2 == 'V') {
        c++
        vm.datacollection.datasets.push({
          label: 'S' + c,
          fill: false,
          backgroundColor: 'rgba(255,0,0,1)',
          borderColor: 'rgba(255,0,0,0.4)',
          data: vm.s2_data,
        })
      }
      if (vm.vehicleSel.sonda_3 == 'T' || vm.vehicleSel.sonda_3 == 'V') {
        c++
        vm.datacollection.datasets.push({
          label: 'S' + c,
          fill: false,
          backgroundColor: 'rgba(0,255,0,1)',
          borderColor: 'rgba(0,255,0,0.4)',
          data: vm.s3_data,
        })
      }
      if (vm.vehicleSel.sonda_4 == 'T' || vm.vehicleSel.sonda_4 == 'V') {
        c++
        vm.datacollection.datasets.push({
          label: 'S' + c,
          fill: false,
          backgroundColor: 'rgba(255,255,0,1)',
          borderColor: 'rgba(255,255,0,0.4)',
          data: vm.s4_data,
        })
      }
      vm.chartOpt = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Temperatura',
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
              scaleLabel: {
                display: true,
                labelString: 'Temperatura C°',
              },
            },
          ],
          xAxes: [
            {
              type: 'time',
              time: {
                unit: 'hour',
                min: this.startData,
                max: this.endData,
                displayFormats: {
                  hour: 'HH:mm',
                },
              },
              ticks: {
                major: {
                  enabled: true, // <-- This is the key line
                  fontStyle: 'bold', //You can also style these values differently
                  fontSize: 14, //You can also style these values differently
                },
              },
            },
          ],
        },
      }
      vm.flag++
      setTimeout(function () {
        vm.createChart()
      }, 500)
    },
    async doGetPos() {
      const vm = this
      vm.isLoading = true
      const rdata = await ServiceBus._doGetPos(
        vm.tagValues,
        vm.vehicleSel.cod,
        vm.startData,
        vm.endData
      )
      vm.isLoading = false
      if (rdata.length === 0) {
        vm.isLoading = false
        vm.noData = true
      } else {
        vm.isLoading = false
        vm.noData = false
        let obj
        vm.labels = []
        vm.s0_data = []
        vm.s1_data = []
        vm.s2_data = []
        vm.s3_data = []
        vm.s4_data = []
        vm.speed_data = []
        vm.startData = rdata[0].date
        vm.endData = rdata[rdata.length - 1].date

        for (let i = 0; i < rdata.length; i++) {
          obj = rdata[i]
          vm.labels.push(obj.date)
          if (obj.v0 > -777) {
            vm.s0_data.push(obj.v0)
          }
          if (obj.v1 > -777) {
            vm.s1_data.push(obj.v1)
          }
          if (obj.v2 > -777) {
            vm.s2_data.push(obj.v2)
          }
          if (obj.v3 > -777) {
            vm.s3_data.push(obj.v3)
          }
          if (obj.v4 > -777) {
            vm.s4_data.push(obj.v4)
          }
          vm.speed_data.push(obj.speed)
        }
        if (vm.carbFlag) {
          vm.setCarburanteGraphs()
        } else if (vm.tempFlag) {
          vm.setTemperatureGraphs()
        } else {
          vm.setSpeedGraphs()
        }
      }
    },
    getWindowHeight(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      document
        .getElementById(vm.vehiclesOpts.id + 'bw')
        .setAttribute('style', 'height:' + (vm.windowHeight - 150) + 'px')
      document
        .getElementById('linechart')
        .setAttribute('style', 'height:' + (vm.windowHeight - 230) + 'px')
    },
    beforeDestroy() {
      const vm = this
      window.removeEventListener('resize', vm.getWindowHeight)
    },
  },
}
</script>
